import React, { Suspense } from 'react';
import PratusHeader from '../components/headers/PratusHeader';
import { matchRoutes, Outlet, useLocation } from 'react-router';
import SidebarNavProvider from '../components/sidebarNav/SidebarNavProvider';
import ChatSidebarProvider from '../components/GlobalChatSidebar/ChatSidebarProvider';
import Loader from '../components/Loader/Loader';
import ErrorBoundary from '../components/Error/ErrorBoundary';
import GlobalChatSidebar from '../components/GlobalChatSidebar';
import classNames from 'classnames';
import './PratusLayout.scss';

const PratusLayout: React.FC = () => {
  const location = useLocation();
  const mapPage = matchRoutes(
    [{ path: '/hub' }, { path: '/' }, { path: '/task_management/map' }],
    location
  );
  return (
    <SidebarNavProvider>
      <ChatSidebarProvider>
        <div className="pratus-layout">
          <div
            role="status"
            className="tw:flex tw:h-[var(--limited-preview-banner-height)] tw:shrink-0 tw:items-center tw:justify-center tw:border-b tw:border-amber-200 tw:bg-yellow-100 tw:text-[11px] tw:font-medium tw:leading-none tw:text-amber-950"
          >
            Limited Preview Environment
          </div>
          <PratusHeader />
          <div className="pratus-layout-container">
            <main
              className={classNames('pratus-layout-container__main', {
                'pratus-map': mapPage,
              })}
            >
              <ErrorBoundary location={location}>
                <Suspense
                  fallback={<Loader showLoading={true} classes="maincontent" />}
                >
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </main>
            <GlobalChatSidebar />
          </div>
        </div>
      </ChatSidebarProvider>
    </SidebarNavProvider>
  );
};
export default PratusLayout;
